import { z } from 'zod';

/**
 * Guardrails mode determines which version of the guardrails API an organization can access.
 * - 'none': Guardrails are disabled for this organization (default)
 * - 'v1': Organization uses V1 guardrails API (legacy, single guardrail per target)
 * - 'v2': Organization uses V2 guardrails API (multi-guardrail, guardrailResults array)
 */
export enum GuardrailsMode {
  NONE = 'none',
  V1 = 'v1',
  V2 = 'v2',
}

export const GuardrailsModeSchema = z.nativeEnum(GuardrailsMode);

export const OrganizationGuardrailsConfigSchema = z.object({
  organizationId: z.string(),
  mode: GuardrailsModeSchema,
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const AdminOrganizationGuardrailsConfigResponseSchema =
  OrganizationGuardrailsConfigSchema.extend({
    createdAt: z.string().nullable(),
    updatedAt: z.string().nullable(),
  });

export const UpdateOrganizationGuardrailsConfigSchema = z.object({
  mode: GuardrailsModeSchema,
});

export type OrganizationGuardrailsConfigDTO = z.infer<typeof OrganizationGuardrailsConfigSchema>;
export type AdminOrganizationGuardrailsConfigResponseDTO = z.infer<
  typeof AdminOrganizationGuardrailsConfigResponseSchema
>;
export type UpdateOrganizationGuardrailsConfigRequest = z.infer<
  typeof UpdateOrganizationGuardrailsConfigSchema
>;
